define('TescoMobile_Checkout/js/view/security-answer',['Magento_Ui/js/form/element/abstract', 'jquery', 'mage/translate'], function (Component, $, $t) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/form/element/password',
      answerSelector: '.answer-security',
      toggleAnswerSelector: '.toggle-customer-answer'
    },
    showHideAnswer: function () {
      if ($(this.answerSelector).hasClass('masked-text')) {
        $(this.answerSelector).removeClass('masked-text');
        $(this.toggleAnswerSelector).addClass("show").text($t('Hide'));
      } else {
        $(this.answerSelector).addClass('masked-text');
        $(this.toggleAnswerSelector).removeClass("show").text($t('Show'));
      }
    }
  });
});

